import {NgModule} from '@angular/core';
import {MapsModule} from '../../../../components/maps/maps.module';
import {SharedCareproviderModule} from '../../../../app-common/shared-careprovider.module';
import {SharedCmsModule} from '../../../../app-common/shared-cms.module';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatExpansionModule} from '@angular/material/expansion';
import {SharedModule} from '../../../../app-common/shared.module';
import {BookTimeNowModule} from '../../../../components/book-time-now/book-time-now.module';
import {CustomerFeatureComponent} from '../../../../components/careprovider/customer-feature/customer-feature.component';
import {BookingBtnComponent} from '../../../../components/booking-btn/booking-btn.component';
import {MatDialogActions, MatDialogContent, MatDialogTitle} from '@angular/material/dialog';
import {cpru2RoutingComponents, Cpru2RoutingModule} from './cpru2-routing.module';
import {SharedCpruModule} from '../shared-cpru.module';
import {CpruTabsService} from '../../../../services/cpru-tabs.service';
import {MatTabLink, MatTabsModule} from '@angular/material/tabs';
import {CpruTopInfoImgSectionComponent} from './components/cpru-top-info-img-section/cpru-top-info-img-section.component';
import {CpruTopInfoDescSectionComponent} from './components/cpru-top-info-desc-section/cpru-top-info-desc-section.component';
import {CpruSmallWidgetsComponent} from './components/cpru-small-widgets/cpru-small-widgets.component';
import {CpruAboutComponent} from './components/cpru-about/cpru-about.component';
import {CpruRelatedComponent} from './components/cpru-related/cpru-related.component';
import {CpruTopInfoShortComponent} from './components/cpru-top-info-short/cpru-top-info-short.component';
import {CpruReviewsShortComponent} from './components/cpru-reviews-short/cpru-reviews-short.component';
import {CpruQuestionsComponent} from './components/cpru-questions/cpru-questions.component';
import {CpruSurveyComponent} from './components/cpru-survey/cpru-survey.component';
import {CpruSurveyDimensionComponent} from './components/cpru-survey-dimension/cpru-survey-dimension.component';
import {CpruSurveyQuestionsComponent} from './components/cpru-survey-questions/cpru-survey-questions.component';
import {CpruSurveyScoreComponent} from './components/cpru-survey-score/cpru-survey-score.component';
import {CpruSurveyScoreBigComponent} from './components/cpru-survey-score-big/cpru-survey-score-big.component';
import {ClosebyCarouselV3Component} from './components/closeby-carousel-v3/closeby-carousel-v3.component';
import {CpruUpdateComponent} from './components/cpru-update/cpru-update.component';
import {CpruBecomeComponent} from './components/cpru-become/cpru-become.component';
import {CpruReferralComponent} from './components/cpru-referral/cpru-referral.component';
import {ImagesCarouselModule} from '../../../../components/images-carousel/images-carousel.module';
import {UiIconComponent} from '../../../../components/ui/ui-icon/ui-icon.component';
import {UiButtonComponent} from '../../../../components/ui/ui-button/ui-button.component';

@NgModule({
  declarations: [
    cpru2RoutingComponents,
    CpruTopInfoImgSectionComponent,
    CpruTopInfoDescSectionComponent,
    CpruSmallWidgetsComponent,
    CpruAboutComponent,
    CpruRelatedComponent,
    CpruTopInfoShortComponent,
    CpruReviewsShortComponent,
    CpruQuestionsComponent,
    CpruSurveyComponent,
    CpruSurveyDimensionComponent,
    CpruSurveyQuestionsComponent,
    CpruSurveyScoreComponent,
    CpruSurveyScoreBigComponent,
    ClosebyCarouselV3Component,
    CpruUpdateComponent,
    CpruBecomeComponent,
    CpruReferralComponent,
  ],
  imports: [
    SharedModule,
    Cpru2RoutingModule,
    MapsModule,
    SharedCareproviderModule,
    SharedCpruModule,
    SharedCmsModule,
    MatTooltipModule,
    MatExpansionModule,
    // SearchWidgetV2Module,
    BookTimeNowModule,
    CustomerFeatureComponent,
    BookingBtnComponent,
    MatDialogActions,
    MatDialogContent,
    MatDialogTitle,
    MatTabLink,
    MatTabsModule,
    ImagesCarouselModule,
    UiIconComponent,
    UiButtonComponent,
  ],
  providers: [CpruTabsService],
})
export class Cpru2Module {}
